(function () {
  'use strict';

  var routes = window.themeRoutes || {};

  /* ------------------------------------------------------------ drawers */
  function openDrawer(el) {
    if (!el) return;
    el.hidden = false;
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      document.getElementById('drawer-overlay').classList.add('is-open');
      document.getElementById('drawer-overlay').hidden = false;
    });
    document.body.style.overflow = 'hidden';
  }

  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (el) {
      el.classList.remove('is-open');
    });
    var overlay = document.getElementById('drawer-overlay');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      document.querySelectorAll('.drawer').forEach(function (el) {
        if (!el.classList.contains('is-open')) el.hidden = true;
      });
      overlay.hidden = true;
    }, 250);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.dataset.openDrawer));
      return;
    }
    if (e.target.closest('[data-close-drawer]') || e.target.id === 'drawer-overlay') {
      closeDrawers();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort-form] select')) {
      e.target.form.submit();
    }
  });

  /* ------------------------------------------------------------- cart */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCartSection(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('cart-drawer-root');
    var current = document.getElementById('cart-drawer-root');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var countEl = doc.querySelector('.drawer-head .tabnum');
    if (countEl) updateCartCount(parseInt(countEl.textContent.replace(/[^\d]/g, ''), 10) || 0);
  }

  function refreshCartDrawer() {
    var path = window.location.pathname + window.location.search;
    var sep = path.indexOf('?') > -1 ? '&' : '?';
    fetch(path + sep + 'section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(renderCartSection)
      .catch(function () {});
  }

  function cartAdd(items) {
    return fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          throw new Error(data.description || 'Sepete eklenemedi');
        }
        if (data.sections && data.sections['cart-drawer']) renderCartSection(data.sections['cart-drawer']);
        else refreshCartDrawer();
        openDrawer(document.getElementById('cart-drawer'));
        return data;
      });
  }

  document.addEventListener('click', function (e) {
    var promoToggle = e.target.closest('[data-promo-toggle]');
    if (promoToggle) {
      var promoForm = promoToggle.parentElement.querySelector('[data-discount-form]');
      if (promoForm) {
        promoForm.hidden = !promoForm.hidden;
        if (!promoForm.hidden) promoForm.querySelector('input').focus();
      }
    }
  });

  /* Brief label-swap + pulse so a tap always has a visible answer, even
     when the drawer that would otherwise confirm it takes a moment to
     open. Reverts on its own; a second tap before it reverts just resets
     the timer rather than stacking animations. */
  function flashAdded(btn) {
    if (!btn) return;
    if (!btn.dataset.originalLabel) btn.dataset.originalLabel = btn.textContent;
    btn.textContent = window.themeStrings.added || 'Added ✓';
    btn.classList.remove('is-added');
    void btn.offsetWidth;
    btn.classList.add('is-added');
    clearTimeout(btn._flashTimer);
    btn._flashTimer = setTimeout(function () {
      btn.classList.remove('is-added');
      btn.textContent = btn.dataset.originalLabel;
    }, 1400);
  }

  document.addEventListener('submit', function (e) {
    var discountForm = e.target.closest('[data-discount-form]');
    if (discountForm) {
      e.preventDefault();
      var code = discountForm.code.value.trim();
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      return;
    }
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]') || document.querySelector('[data-add-submit][form="' + form.id + '"]');
    if (submitBtn) submitBtn.disabled = true;

    var items = [];
    var mainId = form.querySelector('[name="id"]').value;
    var qtyInput = form.querySelector('[name="quantity"]');
    items.push({ id: parseInt(mainId, 10), quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1 });

    form.querySelectorAll('[data-upsell-checkbox]:checked').forEach(function (cb) {
      var variantId = cb.closest('[data-upsell-row]').querySelector('[data-upsell-variant-id]').value;
      if (variantId) items.push({ id: parseInt(variantId, 10), quantity: 1 });
    });

    cartAdd(items)
      .then(function () {
        flashAdded(submitBtn);
      })
      .catch(function (err) {
        var errBox = form.querySelector('[data-form-error]');
        if (errBox) { errBox.textContent = err.message; errBox.hidden = false; }
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  document.addEventListener('click', function (e) {
    var quickAdd = e.target.closest('[data-quick-add]');
    if (quickAdd) {
      e.preventDefault();
      if (quickAdd.disabled) return;
      var variantId = quickAdd.dataset.variantId;
      var linkedRow = quickAdd.closest('[data-upsell-row]');
      if (linkedRow) {
        var hiddenVariant = linkedRow.querySelector('[data-upsell-variant-id]');
        if (hiddenVariant && hiddenVariant.value) variantId = hiddenVariant.value;
      }
      var ids = variantId.split(',').map(function (id) {
        return { id: parseInt(id, 10), quantity: 1 };
      });
      quickAdd.disabled = true;
      cartAdd(ids)
        .then(function () { flashAdded(quickAdd); })
        .finally(function () { quickAdd.disabled = false; });
      return;
    }
    var cartEditToggle = e.target.closest('[data-cart-edit-toggle]');
    if (cartEditToggle) {
      var variantsBox = cartEditToggle.nextElementSibling;
      if (variantsBox) variantsBox.hidden = !variantsBox.hidden;
      return;
    }
    var cartSwatch = e.target.closest('.cart-line-variants .swatch');
    if (cartSwatch) {
      var swatchGroup = cartSwatch.parentElement;
      swatchGroup.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      cartSwatch.setAttribute('aria-pressed', 'true');

      var variantsRoot = cartSwatch.closest('.cart-line-variants');
      var cartLineEl = cartSwatch.closest('[data-cart-line]');
      var lineIndex = cartLineEl.dataset.cartLine;

      var chosen = {};
      variantsRoot.querySelectorAll('[data-option-name]').forEach(function (g) {
        var active = g.querySelector('[aria-pressed="true"]');
        if (active) chosen[g.dataset.optionName] = active.dataset.optionValue;
      });
      var jsonEl = variantsRoot.querySelector('[data-cart-variants-json]');
      var lineVariants = JSON.parse(jsonEl.textContent);
      var matchedVariant = lineVariants.find(function (v) {
        return v.optionValues.every(function (p) { return chosen[p.name] === p.value; });
      });
      if (matchedVariant) {
        var lineQtyEl = document.querySelector('[data-qty-input="' + lineIndex + '"]');
        var lineQty = parseInt(lineQtyEl.textContent, 10) || 1;
        changeVariant(lineIndex, matchedVariant.id, lineQty);
      }
      return;
    }
    var stepper = e.target.closest('[data-qty-step]');
    if (stepper) {
      var line = stepper.dataset.line;
      var qtyEl = document.querySelector('[data-qty-input="' + line + '"]');
      var current = parseInt(qtyEl.textContent, 10) || 0;
      var next = Math.max(0, current + parseInt(stepper.dataset.qtyStep, 10));
      qtyEl.textContent = next; /* instant feedback; reconciled by the fetch below */
      changeLine(line, next);
      return;
    }
    var remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.dataset.lineRemove, 0);
    }
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var gallery = thumb.closest('.pdp-gallery');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
      setGalleryImage(gallery, thumbs.indexOf(thumb));
    }
    var navBtn = e.target.closest('[data-gallery-prev],[data-gallery-next]');
    if (navBtn) {
      var galleryEl = navBtn.closest('.pdp-gallery');
      var thumbList = Array.prototype.slice.call(galleryEl.querySelectorAll('[data-thumb]'));
      var current = thumbList.findIndex(function (t) { return t.classList.contains('active'); });
      if (current === -1) current = 0;
      var dir = navBtn.hasAttribute('data-gallery-next') ? 1 : -1;
      var next = (current + dir + thumbList.length) % thumbList.length;
      setGalleryImage(galleryEl, next);
    }
  });

  function setGalleryImage(gallery, index) {
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    var target = thumbs[index];
    if (!target) return;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    target.classList.add('active');
    var img = gallery.querySelector('[data-main-image]');
    img.classList.add('is-fading');
    setTimeout(function () {
      img.src = target.dataset.full;
      img.classList.remove('is-fading');
    }, 150);
  }

  function changeLine(line, quantity) {
    fetch(routes.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.sections && cart.sections['cart-drawer']) renderCartSection(cart.sections['cart-drawer']);
        else { updateCartCount(cart.item_count); refreshCartDrawer(); }
      })
      .catch(function () {});
  }

  function changeVariant(line, newVariantId, quantity) {
    /* Shopify has no "swap the variant on this line" call — a line is
       keyed to one variant id. Zero the old line, then add the new
       variant at the same quantity; if it already matches another line
       (same variant, same properties) Shopify merges them, which is the
       correct outcome. */
    fetch(routes.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
    })
      .then(function () {
        return fetch(routes.cartAdd || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: newVariantId, quantity: quantity }], sections: 'cart-drawer' })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) renderCartSection(data.sections['cart-drawer']);
        else refreshCartDrawer();
      })
      .catch(function () {});
  }

  /* --------------------------------------------------- variant picker */
  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', {
        style: 'currency',
        currency: window.shopCurrency || 'TRY'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function initVariantPicker(root) {
    var dataEl = root.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[name="id"]');
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var addBtn = root.querySelector('[data-add-submit]');
    var stickyInfo = root.querySelector('[data-sticky-info]');
    var favBtn = root.querySelector('[data-fav-toggle]');
    var basePriceCents = variants[0] ? variants[0].priceCents : 0;

    function selected() {
      var out = {};
      root.querySelectorAll('[data-option-name][data-scope="main"]').forEach(function (group) {
        var active = group.querySelector('[aria-pressed="true"]');
        if (active) out[group.dataset.optionName] = active.dataset.optionValue;
      });
      return out;
    }

    function findVariant(sel) {
      return variants.find(function (v) {
        return v.optionValues.every(function (pair) { return sel[pair.name] === pair.value; });
      });
    }

    function apply() {
      var sel = selected();
      var variant = findVariant(sel);
      if (!variant) return;
      basePriceCents = variant.priceCents;
      root.dataset.basePriceCents = basePriceCents;
      idInput.value = variant.id;
      if (priceNow) priceNow.textContent = variant.price;
      if (priceWas) {
        if (variant.compareAtPrice) { priceWas.textContent = variant.compareAtPrice; priceWas.hidden = false; }
        else priceWas.hidden = true;
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.dataset.labelAvailable : addBtn.dataset.labelSoldOut;
      }
      if (stickyInfo) stickyInfo.querySelector('b').textContent = variant.title;
      if (favBtn) {
        favBtn.dataset.variantId = variant.id;
        favBtn.dataset.variant = variant.title;
        favBtn.dataset.price = variant.price;
      }
      recomputeUpsellTotal(root, basePriceCents);
    }

    root.querySelectorAll('[data-option-name][data-scope="main"] button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.parentElement.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        apply();
      });
    });

    apply();
  }

  document.querySelectorAll('[data-product-root]').forEach(initVariantPicker);

  /* Delegated (not per-element) on purpose: the cart drawer's upsell row
     gets its innerHTML replaced wholesale on every cart change, which
     would silently detach any addEventListener bound directly to these
     buttons. Delegation on document survives every re-render. */
  document.addEventListener('click', function (e) {
    var upsellSwatch = e.target.closest('[data-upsell-row] .swatch-row.mini .swatch');
    if (!upsellSwatch) return;

    var group = upsellSwatch.parentElement;
    group.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    upsellSwatch.setAttribute('aria-pressed', 'true');

    var row = upsellSwatch.closest('[data-upsell-row]');
    var hiddenId = row.querySelector('[data-upsell-variant-id]');
    var jsonEl = row.querySelector('[data-upsell-variants-json]');
    if (!hiddenId || !jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);

    var chosen = {};
    row.querySelectorAll('[data-option-name]').forEach(function (g) {
      var active = g.querySelector('[aria-pressed="true"]');
      if (active) chosen[g.dataset.optionName] = active.dataset.optionValue;
    });
    var variant = variants.find(function (v) {
      return v.optionValues.every(function (p) { return chosen[p.name] === p.value; });
    });
    if (!variant) return;
    hiddenId.value = variant.id;
    row.dataset.priceCents = variant.priceCents;
    var root = row.closest('[data-product-root]');
    if (root) recomputeUpsellTotal(root, parseInt(root.dataset.basePriceCents, 10) || 0);
  });

  function recomputeUpsellTotal(root, basePriceCents) {
    var totalEl = root.querySelector('[data-upsell-total]');
    if (!totalEl) return;
    var total = basePriceCents || 0;
    root.querySelectorAll('[data-upsell-row]').forEach(function (row) {
      var checkbox = row.querySelector('[data-upsell-checkbox]');
      if (checkbox && !checkbox.checked) return;
      var cents = parseInt(row.dataset.priceCents, 10);
      if (!isNaN(cents)) total += cents;
    });
    totalEl.textContent = formatMoney(total);
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-upsell-checkbox]')) {
      var root = e.target.closest('[data-product-root]');
      if (root) recomputeUpsellTotal(root, parseInt(root.dataset.basePriceCents, 10) || 0);
    }
  });

  /* --------------------------------------------------------- favorites
     Signed-out visitors: localStorage only, same as before. Signed-in
     customers additionally sync through a small Cloud Function, so the
     same list shows up on their other devices — see shop_favorites.ts. */
  var FAV_KEY = 'dh_favorites_v1';
  var customerId = window.dhCustomerId ? String(window.dhCustomerId) : null;

  function loadFavs() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; }
  }
  function saveFavs(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function pushRemoteFavorites(list) {
    if (!customerId || !window.dhFavoritesApi) return;
    fetch(window.dhFavoritesApi, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId: customerId, items: list })
    }).catch(function () {});
  }

  function pullRemoteFavorites() {
    if (!customerId || !window.dhFavoritesApi) return;
    fetch(window.dhFavoritesApi + '?customerId=' + encodeURIComponent(customerId))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var remote = Array.isArray(data.items) ? data.items : [];
        var local = loadFavs();
        var merged = remote.slice();
        local.forEach(function (item) {
          if (!merged.some(function (m) { return m.id === item.id; })) merged.push(item);
        });
        saveFavs(merged);
        renderFavorites();
        syncFavButtons();
        if (merged.length !== remote.length) pushRemoteFavorites(merged);
      })
      .catch(function () {});
  }

  function toggleFav(entry) {
    var list = loadFavs();
    var idx = list.findIndex(function (f) { return f.id === entry.id; });
    if (idx > -1) list.splice(idx, 1);
    else list.push(entry);
    saveFavs(list);
    renderFavorites();
    syncFavButtons();
    pushRemoteFavorites(list);
  }

  function syncFavButtons() {
    var list = loadFavs();
    document.querySelectorAll('[data-fav-toggle]').forEach(function (btn) {
      var id = btn.dataset.id;
      var isFav = list.some(function (f) { return f.id === id; });
      btn.classList.toggle('is-active', isFav);
      btn.setAttribute('aria-pressed', String(isFav));
    });
  }

  function renderFavorites() {
    var body = document.getElementById('favorites-body');
    var countEl = document.getElementById('favorites-count');
    if (!body) return;
    var list = loadFavs();
    countEl.textContent = '(' + list.length + ')';

    if (!list.length) {
      body.innerHTML = '<p class="cart-empty">' + (window.themeStrings.favEmpty || "You haven't saved anything yet.") + '</p>';
      return;
    }

    // Built as real DOM nodes, not innerHTML += strings: every field here
    // (title, variant, image) can come back from the sync endpoint, which
    // trusts only the shape of what it's sent, not its content. `textContent`
    // and property assignment never parse a value as markup, so a favorites
    // row can't smuggle a script tag in even if the stored data is hostile.
    var seen = {};
    body.innerHTML = '';
    list.forEach(function (item) {
      if (seen[item.id]) return;
      var pair = item.pairId ? list.find(function (f) { return f.id === item.pairId; }) : null;
      if (pair) seen[pair.id] = true;
      seen[item.id] = true;

      var card = document.createElement('div');
      card.className = 'fav-card';

      var link = item.url ? document.createElement('a') : document.createElement('div');
      link.className = 'fav-card-link';
      if (item.url) {
        link.href = item.url;
        link.setAttribute('data-close-drawer', '');
      }

      var img = document.createElement('img');
      img.alt = '';
      var imgSrc = item.image || '';
      if (/^\/\//.test(imgSrc)) imgSrc = 'https:' + imgSrc;
      if (/^https:\/\//.test(imgSrc)) img.src = imgSrc;
      link.appendChild(img);

      var meta = document.createElement('div');
      meta.className = 'meta';
      var titleEl = document.createElement('b');
      titleEl.textContent = item.title || '';
      var variantEl = document.createElement('span');
      variantEl.textContent = item.variant || '';
      meta.appendChild(titleEl);
      meta.appendChild(variantEl);
      if (pair) {
        var setTag = document.createElement('span');
        setTag.className = 'set-tag';
        setTag.textContent = window.themeStrings.favSet || 'Saved as a pair';
        meta.appendChild(setTag);
      }
      link.appendChild(meta);
      card.appendChild(link);

      var side = document.createElement('div');
      side.className = 'side';
      var removeBtn = document.createElement('button');
      removeBtn.className = 'fav-heart';
      removeBtn.setAttribute('data-fav-remove', item.id);
      removeBtn.setAttribute('aria-label', 'Remove from favorites');
      removeBtn.textContent = '♥';
      var addBtn = document.createElement('button');
      addBtn.className = 'btn small';
      addBtn.setAttribute('data-quick-add', '');
      addBtn.setAttribute('data-variant-id', item.variantId || '');
      addBtn.textContent = window.themeStrings.add || 'Add to Cart';
      side.appendChild(removeBtn);
      side.appendChild(addBtn);
      card.appendChild(side);

      body.appendChild(card);
    });
  }

  document.addEventListener('click', function (e) {
    var favBtn = e.target.closest('[data-fav-toggle]');
    if (favBtn) {
      e.preventDefault();
      toggleFav({
        id: favBtn.dataset.id,
        pairId: favBtn.dataset.pairId || null,
        variantId: favBtn.dataset.variantId,
        title: favBtn.dataset.title,
        variant: favBtn.dataset.variant || '',
        image: favBtn.dataset.image,
        price: favBtn.dataset.price,
        url: favBtn.dataset.url || ''
      });
      return;
    }
    var favRemove = e.target.closest('[data-fav-remove]');
    if (favRemove) {
      var list = loadFavs().filter(function (f) { return f.id !== favRemove.dataset.favRemove; });
      saveFavs(list);
      renderFavorites();
      syncFavButtons();
      pushRemoteFavorites(list);
    }
  });

  window.themeStrings = window.themeStrings || {};
  renderFavorites();
  syncFavButtons();
  pullRemoteFavorites();
})();
